module.exports = __webpack_public_path__ + "img/type7.2a3a4c9d.png";